<script setup lang="ts">
import { KsCollapsibleRoot } from '@aschehoug/kloss-2'
</script>

<template>
  <KsCollapsibleRoot class="collapsible-root">
    <slot />
  </KsCollapsibleRoot>
</template>
